import {
  Case,
  User,
  Category,
  Chat,
  Message,
  Report,
  Tag,
  MessageTemplate,
  Role,
  Notification
} from "../../api/classes";

export const LOAD_CACHED_CASES = "LOAD_CACHED_CASES";
export const FETCH_CASES = "FETCH_CASES";
export const FETCH_ROLES = "FETCH_ROLES";
export const FETCH_USERS = "FETCH_USERS";
export const FETCH_MAIL_LIST = "FETCH_MAIL_LIST";

export const FETCH_CATEGORIES = "FETCH_CATEGORIES";
export const FETCH_CHATS = "FETCH_CHATS";
export const FETCH_MESSAGES = "FETCH_MESSAGES";
export const FETCH_REPORTS = "FETCH_REPORTS";
export const FETCH_TAGS = "FETCH_TAGS";
export const BIND_MESSAGES = "BIND_MESSAGES";
export const FETCH_MESSAGE_TEMPLATES = "FETCH_MESSAGE_TEMPLATES";
export const SET_CASE_UPDATE_REQUIRED = "SET_CASE_UPDATE_REQUIRED";

export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";

export interface CaseAction {
  type: string;
  cases?: Case[];
  users?: User[];
  roles?: Role[];
  mailList?: User[];
  categories?: Category[];
  chats?: Chat[];
  messages?: Message[];
  reports?: Report[];
  tags?: Tag[];
  reportId?: number;
  caseId?: number;
  messageIds?: number[];
  messageTemplates?: MessageTemplate[];
  cacheLoaded?: boolean;
  notifications?: Notification[];
}

export interface CaseState {
  list: Case[];
  casesUpdateRequired: boolean;
  users?: User[];
  roles?: Role[];
  mailList?: User[];
  categories?: Category[];
  chats?: Chat[];
  messages?: Message[];
  reports?: Report[];
  tags?: Tag[];
  messageTemplates?: MessageTemplate[];
  cacheLoaded?: boolean;
  notifications?: Notification[];
}



// WEBPACK FOOTER //
// ./src/store/cases/types.ts